<section class="service_sec creative" id="creative" data-scroll-section>
  <div class="is_mobile_image">
    <figure
      class="section_img lazyload"
      style="background-image: url('assets/about/creative.jpg')"
    ></figure>
  </div>
  <div
    class="img_wraper"
    data-scroll
    data-scroll-repeat
    data-scroll-sticky
    data-scroll-target="#creative"
  >
    <span data-scroll data-scroll-speed="1.5">
      <figure
        class="section_img lazyloaded"
        style="background-image: url('assets/about/creative.jpg')"
      ></figure>
    </span>
  </div>
  <div class="row">
    <div class="content_div" data-scroll data-scroll-speed="1">
      <div class="sec_head">
        <span class="for_mob">Services</span>
        <h2>Stories I Craft</h2>
      </div>
      <p>
        Through innovative design and strategic development, I transform your vision into
        captivating stories that resonate with your audience and make a lasting impact.
      </p>
      <a routerLink="services" class="common-arrow">
        Show Services
        <span><i class="fa-solid fa-arrow-right"></i></span>
      </a>
    </div>
    <div class="for_mob_scrll">
      <div class="col_item">
        <div class="item_div">
          <h3>Application</h3>
          <div class="img_content">
            <figure class="lazyloaded" style="background-image: url('assets/about/running.jpg')">
              <a routerLink="services" (click)="selectTab('creative')"
                ><i class="fa-solid fa-arrow-right"></i
              ></a>
            </figure>
            <p>
              I specialize in creating innovative mobile apps that provide great user experiences.
              Working with both the <b>iOS</b> and <b>Android</b> platforms personally, I've created
              <b>user-friendly</b> apps that run nicely. My approach focuses on understanding
              customer needs and converting them into simple but effective mobile solutions.
            </p>
          </div>
        </div>
        <div class="item_div">
          <h3>Website</h3>
          <div class="img_content">
            <figure
              class="lazyloaded"
              style="background-image: url('assets/about/development.jpg')"
            >
              <a routerLink="services" (click)="selectTab('web')"
                ><i class="fa-solid fa-arrow-right"></i
              ></a>
            </figure>
            <p>
              I am here to help you to create your <b>ideal</b> online space. Working closely with
              designers and writers, I ensure your brand's personality shines through every page.
              This website will be your brand's true <b>home</b>, where anyone can visit and connect
              with what you stand for.
            </p>
          </div>
        </div>
        <div class="item_div">
          <h3>Software Development</h3>
          <div class="img_content">
            <figure
              class="lazyloaded"
              style="background-image: url('assets/about/performance.jpg')"
            >
              <a routerLink="services" (click)="selectTab('performance')"
                ><i class="fa-solid fa-arrow-right"></i
              ></a>
            </figure>
            <p>
              I have many years of expertise in <b>developing</b> and <b>supervising</b> many kinds
              of software programs, such as <b>HRM </b>(Human Resource Management) tools and
              <b>CRM </b>(customer relationship management) systems. Creating stable backend
              systems, merging different technologies, and providing
              <b>smooth user experiences</b> have all been parts of my job.
            </p>
          </div>
        </div>
        <div class="item_div">
          <h3>Content</h3>
          <div class="img_content">
            <figure class="lazyloaded" style="background-image: url('assets/about/content.jpg')">
              <a routerLink="services" (click)="selectTab('content')"
                ><i class="fa-solid fa-arrow-right"></i
              ></a>
            </figure>
            <p>
              Words have their <b>own power</b> and can <b>express</b> meaning when they are
              properly used. Together, we <b>carefully</b> create words to offer your brand the
              <b>ideal identity</b> and message it needs to send to its viewers.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
